import MainMenuBlock from '../mainMenuBlock/MainMenuBlock';
import JPNonTransitGeneralInfo from '../JPNonTransitGeneralInfo/JPNonTransitGeneralInfo';
import JPTransitGeneralInfo from '../JPTransitGeneralInfo/JPTransitGeneralInfo';
import JPNonTransitStepsInfo from '../JPNonTransitStepsInfo/JPNonTransitStepsInfo';
import JPTransitStepsInfo from '../JPTransitStepsInfo/JPTransitStepsInfo';
import SeeMapAndDetailsBtn from '../seeMapAndDetailsBtn/SeeMapAndDetailsBtn';

export default MainMenuBlock.extend({
	template: require('./jpRouteDetails.hbs'),
	componentClass: 'jp-route-details',
	events: {
		'click .jp-route-details-go-back': 'onClickGoBack',
		'click .jp-route-details-close': 'onClickClose'
	},

	panelCollapsed: undefined,

	createConfigSubcomponents() {},

	addListeners() {
		google.maps.event.addDomListener(this.widget.map, 'resize', () => {
			this.setHeight();
		});
	},

	setHeight() {
		const widgetHeight = this.widget.getHeight();
		const heightDetailsHeader = 160;
		const marginTopMainPanel = 10;
		const googleLogoHeight = 28;
		const stepsInfoContainerDomElement = this.$el.find(
			'.jp-route-details-steps-info-container'
		);
		if (this.widget.isMobileVersion) {
			stepsInfoContainerDomElement.css(
				'height',
				`${widgetHeight - heightDetailsHeader}px`
			);
		} else {
			stepsInfoContainerDomElement.css(
				'max-height',
				`${widgetHeight -
					heightDetailsHeader -
					marginTopMainPanel -
					googleLogoHeight}px`
			);
		}
	},

	updateRouteDetails(
		route,
		originText,
		destinationText,
		travelMode,
		originIsMainHotel,
		panelCollapsed
	) {
		if (panelCollapsed !== undefined) {
			// if this param not exists, the panel use the last state
			this.panelCollapsed = panelCollapsed;
		}
		this.addListeners();
		this.templateConfig = {
			route: route,
			fromDataStr: originText,
			toDataStr: destinationText,
			mobileClass: this.widget.isMobileVersion
				? 'lmm-jp-route-details-mobile-version'
				: ''
		};
		let generalInfoComponent;
		let stepsInfoComponent;
		if (this.isTransitLeg(route.legs[0])) {
			generalInfoComponent = this.createTransitGeneralInfo(route, travelMode);
			stepsInfoComponent = this.createTransitStepsInfo(
				route,
				originText,
				destinationText
			);
		} else {
			generalInfoComponent = this.createNonTransitGeneralInfo(
				route,
				travelMode
			);
			stepsInfoComponent = this.createNonTransitStepsInfo(
				route,
				originText,
				destinationText,
				originIsMainHotel
			);
		}
		this.show();
		this.$el.replaceWith(this.render().$el);
		if (this.panelCollapsed) {
			this.$el.addClass('jp-route-details-collapse');
		}
		this.$el
			.find(`.${this.componentClass}-general-info`)
			.append(generalInfoComponent.$el);
		let seeMapAndDetailsBtnComponent = this.createSeeMapAndDetailsBtnComponent(
			this.panelCollapsed
		);
		generalInfoComponent.$el
			.find('.see-map-details-btn')
			.append(seeMapAndDetailsBtnComponent.$el);
		this.$el
			.find(`.${this.componentClass}-steps-info-container`)
			.append(stepsInfoComponent.$el);
		this.setHeight();
	},

	isTransitLeg(leg) {
		return leg.steps.some(step => step.travel_mode === 'TRANSIT');
	},

	createNonTransitGeneralInfo(route, travelMode) {
		let jpNonTransitGeneralInfo = new JPNonTransitGeneralInfo({
			componentClass: 'jp-non-transit-general-info',
			widget: this.widget,
			bus: this.widget.bus,
			componentConstructorClass: 'JPNonTransitGeneralInfo',
			properties: {
				travelMode: travelMode,
				route: route.legs[0],
				summary: route.summary
			}
		});
		return jpNonTransitGeneralInfo;
	},

	createNonTransitStepsInfo(
		route,
		originText,
		destinationText,
		originIsMainHotel
	) {
		let jpNonTransitStepsInfo = new JPNonTransitStepsInfo({
			componentClass: 'jp-non-transit-steps-info',
			widget: this.widget,
			bus: this.widget.bus,
			componentConstructorClass: 'JPNonTransitStepsInfo',
			properties: {
				route: route.legs[0],
				originText: originText,
				destinationText: destinationText,
				originIsMainHotel: originIsMainHotel
			}
		});
		return jpNonTransitStepsInfo;
	},

	createTransitGeneralInfo(route, travelMode) {
		let jpTransitGeneralInfo = new JPTransitGeneralInfo({
			componentClass: 'jp-transit-general-info',
			widget: this.widget,
			bus: this.widget.bus,
			componentConstructorClass: 'JPTransitGeneralInfo',
			properties: {
				travelMode: travelMode,
				route: route.legs[0]
			}
		});
		return jpTransitGeneralInfo;
	},

	createTransitStepsInfo(route, originText, destinationText) {
		let jpTransitStepsInfo = new JPTransitStepsInfo({
			componentClass: 'jp-transit-steps-info',
			widget: this.widget,
			bus: this.widget.bus,
			componentConstructorClass: 'JPTransitStepsInfo',
			properties: {
				route: route.legs[0],
				originText: originText,
				destinationText: destinationText
			}
		});
		return jpTransitStepsInfo;
	},

	onClickGoBack() {
		this.hide();
		this.bus.trigger('CLICK_IN_BACK_DETAILS_ROUTE');
	},

	onClickClose() {
		this.hide();
		const closeDirectionsBox = false;
		this.bus.trigger('directions_btn_event', closeDirectionsBox);
		this.stopListening();
	},

	createSeeMapAndDetailsBtnComponent(collapsed) {
		return new SeeMapAndDetailsBtn({
			componentClass: 'jp-see-map-and-details-btn',
			widget: this.widget,
			bus: this.widget.bus,
			componentConstructorClass: 'SeeMapAndDetailsBtn',
			parent: this,
			properties: {
				seeMapState: !collapsed
			}
		});
	},

	collapseDetailsPanel(collapsedPanel) {
		this.panelCollapsed = collapsedPanel;
		this.$el.toggleClass('jp-route-details-collapse');
	}
});



// WEBPACK FOOTER //
// ./src/components/JPRouteDetails/JPRouteDetails.js